import styled from "styled-components";
import theme from "../../../Styles/theme";

export const Container = styled.div`
    display:flex;
    align-items: center;
    flex-direction: column;
    justify-content:center;
`;


export const Title = styled.h1`

    font-size: max(10px, 1.2vw);

    color: ${theme.colors.dark};

`;


export const OkayButton = styled.button`

    font-size: max(10px, 1.2vw);

    color: ${theme.colors.dark};

    background-color: ${theme.colors.darkGrey};

    padding:0.6vh 1vw;
    cursor: pointer;
    &:hover{
        opacity: 0.7;
    }

    border-radius: 0.25rem;
    margin-top:1vh;

`;